export default "__VITE_ASSET__lZAHmOeV__"